/** Persists the SSO provider chosen on signup across the OAuth redirect. */
export const SSO_SIGNUP_PROVIDER_KEY = 'SSO-SIGNUP-PROVIDER';
